/* Ottie free merino offer (snippets/ottie-gift-cart.liquid supplies the config).
   2 apparel items (tees, long sleeves, thermals, leggings) = 1 free gift, 4 = both.
   The Shopify automatic discount "Free merino gift" sets the prices; this script shows progress,
   adds the chosen gift (line property _ottie_gift) and removes gifts the cart
   no longer earns. */
(function () {
  var cfgEl = document.getElementById('OttieGiftConfig');
  if (!cfgEl) return;
  var cfg;
  try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }

  var types = (cfg.types || []).map(function (t) { return String(t).trim().toLowerCase(); }).filter(Boolean);
  var products = cfg.products || [];
  var choice = {};   // product id -> array of chosen option values
  var notice = '', noticeUntil = 0;
  var busy = false, again = false;

  function isGift(item) { return !!(item.properties && item.properties._ottie_gift); }
  function isShirt(item) { return !isGift(item) && types.indexOf(String(item.product_type || '').toLowerCase()) > -1; }
  function allowed(n) { return n >= 4 ? 2 : (n >= 2 ? 1 : 0); }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function plural(n, word) { return n + ' more ' + word + (n === 1 ? '' : 's'); }

  function getCart() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
  }

  function rebuildThemeCart() {
    document.dispatchEvent(new CustomEvent('cart:build'));
  }

  function refresh() {
    if (busy) { again = true; return; }
    busy = true;
    getCart().then(enforce).then(render).catch(function () {}).then(function () {
      busy = false;
      if (again) { again = false; refresh(); }
    });
  }

  // Keep at most one gift line per product, quantity 1, and no more than the cart earns.
  function enforce(cart) {
    var shirts = 0;
    cart.items.forEach(function (i) { if (isShirt(i)) shirts += i.quantity; });
    var limit = allowed(shirts);
    var seen = {}, kept = 0, removed = 0, changes = [];
    cart.items.slice().reverse().forEach(function (i) {   // oldest first, so the first pick stays
      if (!isGift(i)) return;
      var keep = (!seen[i.product_id] && kept < limit) ? 1 : 0;
      if (keep) { seen[i.product_id] = true; kept++; } else { removed++; }
      if (i.quantity !== keep) changes.push({ id: i.key, quantity: keep });
    });
    if (!changes.length) return cart;
    if (removed) { notice = 'We took a free gift out because the cart now has fewer apparel items.'; noticeUntil = Date.now() + 8000; }
    return changes.reduce(function (p, c) {
      return p.then(function () {
        return fetch('/cart/change.js', {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(c)
        });
      });
    }, Promise.resolve()).then(function () {
      rebuildThemeCart();
      return getCart();
    });
  }

  function variantFor(p) {
    var opts = choice[p.id];
    if (!opts) {
      var first = p.variants.filter(function (v) { return v.available; })[0] || p.variants[0];
      opts = choice[p.id] = first.options.slice();
    }
    return p.variants.filter(function (v) {
      return v.options.every(function (o, idx) { return o === opts[idx]; });
    })[0];
  }

  function card(p) {
    var v = variantFor(p);
    var opts = choice[p.id];
    var html = '<div class="oc__card">';
    if (v && v.image) html += '<img src="' + esc(v.image) + '" alt="" loading="lazy" width="300" height="300">';
    html += '<p class="oc__title">' + esc(p.title) + '</p>';
    p.options.forEach(function (name, idx) {
      var values = [];
      p.variants.forEach(function (x) { if (values.indexOf(x.options[idx]) === -1) values.push(x.options[idx]); });
      if (values.length < 2) return;
      html += '<div class="oc__opts" role="group" aria-label="' + esc(name) + '">';
      values.forEach(function (val) {
        html += '<button type="button" data-og-opt="' + p.id + '|' + idx + '|' + esc(val) + '" class="' + (opts[idx] === val ? 'is-on' : '') + '" aria-pressed="' + (opts[idx] === val) + '">' + esc(val) + '</button>';
      });
      html += '</div>';
    });
    var ok = v && v.available;
    html += '<button type="button" class="oc__add" data-og-add="' + (ok ? v.id : '') + '"' + (ok ? '' : ' disabled') + '>' + (ok ? 'Add free' : 'Sold out') + '</button>';
    return html + '</div>';
  }

  function bar(n) {
    var pct = Math.min(n, 4) / 4 * 100;
    var stops = [[0, ''], [2, '2 · free gift'], [4, '4 · 2nd free gift']];
    var html = '<div class="oc__bar" aria-hidden="true"><i style="width:' + pct + '%"></i>';
    stops.forEach(function (s) {
      html += '<div class="oc__stop' + (n >= s[0] ? ' is-on' : '') + '" style="left:' + (s[0] / 4 * 100) + '%"><span>' + s[1] + '</span></div>';
    });
    return html + '</div>';
  }

  function message(n, giftsIn, limit) {
    var open = limit - giftsIn;
    if (n === 0) return 'Buy <b>any 2 merino apparel items</b> and get a <b>free neck gaiter or hand warmers</b>.';
    if (n === 1) return 'Add <b>1 more apparel item</b> to get a <b>free neck gaiter or hand warmers</b>.';
    if (open > 0 && limit === 1) return '<b>You\'ve unlocked a free gift.</b> Pick one:';
    if (open > 0) {
      return '<b>' + (open === 2 ? 'You\'ve unlocked 2 free gifts.' : 'Your second free gift is unlocked.') + '</b> Pick ' + (open === 2 ? 'them' : 'it') + ' below:';
    }
    if (n < 4) return '<b>Your free gift is in.</b> Add <b>' + plural(4 - n, 'apparel item') + '</b> to get <b>a second free gift</b>.';
    return '<b>You\'ve got 2 free gifts:</b> neck gaiter and hand warmers.';
  }

  function render(cart) {
    var panels = document.querySelectorAll('[data-ottie-gift-panel]');
    if (!panels.length) return;
    var n = 0, inCart = {}, giftsIn = 0;
    cart.items.forEach(function (i) {
      if (isShirt(i)) n += i.quantity;
      if (isGift(i)) { inCart[i.product_id] = true; giftsIn += i.quantity; }
    });
    var limit = allowed(n);
    var html = '';
    if (notice && Date.now() < noticeUntil) html += '<p class="oc__notice" role="status">' + esc(notice) + '</p>';
    html += '<p class="oc__msg">' + message(n, giftsIn, limit) + '</p>';
    if (giftsIn < limit) {
      var options = products.filter(function (p) { return !inCart[p.id]; });
      if (options.length) html += '<div class="oc__pick">' + options.map(card).join('') + '</div>';
    } else {
      html += bar(n);
    }
    panels.forEach(function (el) {
      el.innerHTML = html;
      el.hidden = cart.item_count === 0;
    });
  }

  document.addEventListener('click', function (evt) {
    var opt = evt.target.closest('[data-og-opt]');
    if (opt) {
      var parts = opt.getAttribute('data-og-opt').split('|');
      var pid = parseInt(parts[0], 10);
      choice[pid][parseInt(parts[1], 10)] = parts.slice(2).join('|');
      getCart().then(render);
      return;
    }
    var add = evt.target.closest('[data-og-add]');
    if (add && add.getAttribute('data-og-add')) {
      add.disabled = true;
      add.textContent = 'Adding…';
      fetch('/cart/add.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(add.getAttribute('data-og-add'), 10), quantity: 1, properties: { _ottie_gift: 'Free gift' } }] })
      }).then(function () {
        rebuildThemeCart();
        refresh();
      });
    }
  });

  ['cart:updated', 'ajaxProduct:added', 'cart:open'].forEach(function (name) {
    document.addEventListener(name, function () { setTimeout(refresh, 50); });
  });
  refresh();
})();
